import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(({ palette }) => ({
  circular: {
    color: palette.primary.main,
  },
}))
